import { ReactComponent as MoreIcon } from '@paradigm/icons/src/mailru/navigation/more.svg';
import classNames from 'clsx';
import React, { memo, ReactElement, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { DatalistPic } from 'reactApp/ui/Mobile/Datalist/DatalistPic/DatalistPic';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { LinkIcon } from 'reactApp/ui/VKUIIcons';
import { noop } from 'reactApp/utils/helpers';

import styles from './DatalistThumbItem.css';
import { IProps } from './DatalistThumbItem.types';

export const DatalistThumbItem = memo(
    ({
        isFolder,
        kind,
        thumbUrl,
        ext,
        isVirus,
        isSelected,
        isSelecting,
        name,
        weblink,
        onClick,
        onOptions,
        onShare,
        id,
        author,
        onQuotaCleanerSelect,
    }: IProps): ReactElement => {
        const [isLoaded, setLoaded] = useState<boolean>(false);

        const onLoaded = useCallback(() => setLoaded(true), []);

        const storage = useSelector(getCurrentStorage);
        const { isPublic, isQuotaCleaner } = getStorage(storage);

        return (
            <div
                className={classNames({
                    [styles.root]: true,
                    [styles.root_loaded]: isLoaded || isFolder || !thumbUrl?.src,
                    [styles.root_selecting]: isSelecting,
                    [styles.root_selected]: isSelected,
                })}
                onClick={onClick}
                data-qa-id={id}
                data-qa-type={isFolder ? 'folder' : 'file'}
                data-qa-name={ext ? `${name}.${ext}` : name}
            >
                <div className={styles.content}>
                    <div className={styles.check} onClick={onQuotaCleanerSelect}>
                        <DataListControl type="check" active={isSelected} size={28} viewType={EViewMode.thumbs} />
                    </div>
                    <div className={styles.pic}>
                        <DatalistPic
                            isFolder={isFolder}
                            ext={ext || ''}
                            kind={kind}
                            thumbUrl={thumbUrl}
                            isVirus={isVirus}
                            viewMode={EViewMode.thumbs}
                            onLoaded={onLoaded}
                            author={author}
                        />
                    </div>
                    <div className={styles.name}>
                        <NameComponent name={name} extension={ext} truncate />
                    </div>

                    <div className={styles.buttons}>
                        {!isPublic && !!weblink && (
                            <div className={styles.button_publish} onClick={isSelecting ? noop : onShare}>
                                <LinkIcon className={styles.icon} width={14} height={14} />
                            </div>
                        )}
                        {!isQuotaCleaner && (
                            <div className={styles.button_more} onClick={isSelecting ? noop : onOptions}>
                                <MoreIcon className={styles.icon} width={20} height={20} fill="currentColor" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
);

DatalistThumbItem.displayName = 'DatalistThumbItem';
